import React from 'react';
import AdminNavbar from './AdminNavbar';
import AdminToolbar from './AdminToolbar';

// Layout wrapper for admin pages, includes sidebar/navbar, top toolbar, and content area
const AdminLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)]">
      <AdminNavbar />
      <div className="flex-1 flex flex-col min-w-0 w-full">
        <AdminToolbar />
        <div className="flex-1 min-w-0 w-full px-5 py-4 space-y-4 overflow-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
